<template>
  <div class="popup-wrap" v-if="visible">
    <!--  -->
    <template v-if="maskClickable">
      <div :class="['popup-mask', maskClickable ? 'clickable' : '']" @click="hide"></div>
    </template>
    <template v-else>
      <div class="popup-mask"></div>
    </template>
    <!-- 弹窗主体 -->
    <div :class="['popup-main__wrap', position, 'animated', effect, mode + '-pop_content']">
      <div :class="['popup-main', ['toast', 'message', 'tooltip', 'loading'].indexOf(mode) != -1 ? 'no-btns' : '']">
        <!-- Toast / Message / ToolTip -->
        <template v-if="mode == 'toast' || mode == 'message' || mode == 'tooltip'">
          <div class="popup__toast">
            <div class="title" v-if="title">{{title}}</div>
            <div class="msg-box">
              <i class="iconfont info" v-if="iconCls == 'info'">&#xe640;</i>
              <i class="iconfont success" v-if="iconCls == 'success'">&#xe640;</i>
              <i class="iconfont failure" v-if="iconCls == 'failure'">&#xe633;</i>
              <span class="msg">{{message}}</span>
            </div>
          </div>
        </template>
        <!-- Loading -->
        <template v-else-if="mode == 'loading'">
          <div class="popup__loading">
            <img class="loading-icon" src="@/assets/imgs/loader.gif" />
            <!-- <img class="loading-icon" :src="iconSrc" /> -->
            <div class="loading-msg" v-if="message">{{message}}</div>
          </div>
        </template>
        <!-- Alert -->
        <template v-else-if="mode == 'alert'">
          <div class="popup__alert">
            <i class="iconfont icon-close" v-if="closable" @click="hide">&#xe674;</i>
            <div class="title">{{title}}</div>
            <div class="msg">{{message}}</div>
            <div class="btns-group">
              <button class="c-button c-button--primary" @click="trigger('confirm')">{{confirmText}}</button>
            </div>
          </div>
        </template>
        <!-- Confirm -->
        <template v-else-if="mode == 'confirm'">
          <div class="popup__confirm">
            <i class="iconfont icon-close" v-if="closable" @click="hide">&#xe674;</i>
            <div class="title">{{title}}</div>
            <div class="msg">{{message}}</div>
            <div class="btns-group">
              <button class="c-button" v-if="showCancel" @click="trigger('cancel')">{{cancelText}}</button>
              <button class="c-button c-button--primary" @click="trigger('confirm')">{{confirmText}}</button>
            </div>
          </div>
        </template>
        <!-- Prompt -->
        <template v-else-if="mode == 'prompt'">
          <div class="popup__prompt">
            <i class="iconfont icon-close" v-if="closable" @click="hide">&#xe674;</i>
            <div class="title">{{title}}</div>
            <div class="msg">{{message}}</div>
            <input type="text" class="txtInput" v-model="txtIpt" :placeholder="placeholder" />
            <div class="btns-group">
              <button class="c-button" v-if="showCancel" @click="trigger('cancel')">{{cancelText}}</button>
              <button class="c-button c-button--primary" @click="trigger('confirm')">{{confirmText}}</button>
            </div>
          </div>
        </template>
        <!-- Dialog / Modal / Popup -->
        <template v-else-if="mode == 'dialog' || mode == 'modal' || mode == 'popup'">
          <slot></slot>
        </template>
        <!-- Unknown -->
        <template v-else>
          {{mode}}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    options: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      mode: 'toast',
      effect: 'fadeIn',
      position: 'center',
      enableMask: true,
      maskClickable: true,
      closable: false,
      autoClose: true,
      duration: 1500,
      title: "",
      message: "",
      placeholder: "",
      iconCls: "",
      iconSrc: "",
      showCancel: false,
      cancelText: "取消",
      confirmText: "确定",
      visible: false,
      // 
      txtIpt: ""
    }
  },
  created() {
    if (this.options) this.initWithParams(this.options);
  },
  methods: {
    initWithParams(args) {
      let { visible, mode, effect, position, enableMask, maskClickable, closable, autoClose, duration, title, message, placeholder, iconCls, iconSrc, showCancel, cancelText, confirmText } = args;
      // 
      this.mode = this.checkVariable(mode, ['toast', 'message', 'tooltip', 'loading', 'alert', 'confirm', 'prompt', 'dialog', 'modal', 'popup'], 'message');
      this.effect = this.checkVariable(effect, ['fade', 'fadeIn', 'slideIn'], 'fadeIn');
      this.position = this.checkVariable(position, ['center', 'top', 'bottom', 'left', 'right'], 'center');
      this.enableMask = this.checkVariable(enableMask, [true, false], true);
      this.maskClickable = this.checkVariable(maskClickable, [true, false], true);
      this.closable = this.checkVariable(closable, [true, false], false);
      this.autoClose = this.checkVariable(autoClose, [true, false], false);
      this.duration = this.checkVariable(duration, [Number], 1500);
      this.title = this.checkVariable(title, [String], "");
      this.message = this.checkVariable(message, [String], "");
      this.placeholder = this.checkVariable(placeholder, [String], "请输入");
      this.iconCls = this.checkVariable(iconCls, [String], "");
      this.iconSrc = this.checkVariable(iconSrc, [String], "");
      this.showCancel = this.checkVariable(showCancel, [true, false], false);
      this.cancelText = this.checkVariable(cancelText, [String], "取消");
      this.confirmText = this.checkVariable(confirmText, [String], "确定");
      this.visible = this.checkVariable(visible, [true, false], false);
      // 
      if (this.visible && this.autoClose && this.duration) {
        setTimeout(() => {
          this.hide();
        }, this.duration);
      }
    },
    /**
     * 检查变量的值是否为指定数组中的项或类型，否则返回默认值
     * @param {*} target - 待检查变量
     * @param {*[]} optionalValues - 可选值
     * @param {*} defaultValue - 默认值
     */
    checkVariable(target, optionalValues, defaultValue) {
      if (target != undefined && Array.isArray(optionalValues) && optionalValues.length && defaultValue != undefined) {
        return optionalValues.some(item => {
          return target === item || (target.constructor && target.constructor === item);
        }) ? target : defaultValue;
      } else if (defaultValue != undefined) {
        return defaultValue;
      } else {
        return target;
      }
    },
    show() {
      this.visible = true;
      this.$emit('show');
    },
    hide() {
      this.visible = false;
      this.$emit('hide');
    },
    toggle() {
      this.visible ? this.hide() : this.show();
    },
    trigger(type) {
      this.$emit(type);
      this.hide();
      typeof this.btnClickHandler == "function" && this.btnClickHandler(type, this.txtIpt);
    }
  }
}
</script>

<style lang="scss" scoped>
  .popup-wrap {
    .popup-mask { position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 99999; background: rgba(0, 0, 0, 0.3); }
    .popup-main__wrap {
      position: fixed; z-index: 1000000;
      &.center { top: 50%; left: 50%; transform: translate(-50%, -50%); }
      .popup-main {
        min-width: 300px; padding: 3.125rem 1rem 1.875rem 1rem; background: #FFFFFF; position: relative; border-radius: 4px; overflow: hidden;
        &.no-btns { padding: 3.125rem 1rem; }
        // 
        .popup__toast, .popup__message, .popup__tooltip {
          display: flex; flex-direction: column; justify-content: flex-start; align-items: center;
          .title { font-size: 1.25rem; color: #282828; font-weight: 700; line-height: 1; margin-bottom: 1.25rem; }
          .msg-box {
            display: flex; justify-content: center; align-items: center; line-height: 1;
            .iconfont {
              font-size: 1.5rem; line-height: 1.5rem;
              &.success { color: #608C82; }
              &.failure { color: #000000; }
            }
            .msg { font-size: 1rem; color: #282828; line-height: 1.5rem; }
            .iconfont + .msg { margin-left: 1.25rem; }
          }
        }
        // 
        .popup__loading {
          display: flex; flex-direction: column; justify-content: flex-start; align-items: center;
          .loading-icon { width: 5rem; height: auto; max-height: 5rem; }
          .loading-msg { font-size: 0.75rem; color: #282828; line-height: 0.75rem; margin-top: 1.25rem; }
        }
        //
        .popup__alert, .popup__confirm, .popup__prompt {
          display: flex; flex-direction: column; justify-content: flex-start; align-items: center;
          .icon-close { font-size: 30px; color: #D0D0D0; line-height: 1; position: absolute; top: 1.25rem; right: 1.25rem; cursor: pointer; }
          .title { font-size: 1.25rem; color: #282828; font-weight: 700; line-height: 1; margin-bottom: 1.25rem; }
          .msg { font-size: 0.875rem; color: #5E5E5E; font-weight: 400; line-height: 1; }
          .btns-group {
            display: flex; justify-content: center; align-items: center; margin-top: 1.875rem;
            .c-button:last-child:not(:first-child) { margin-left: 1.875rem; }
          }
        }
        // 
        .popup__prompt {
          .msg { width: 100%; }
          .txtInput {
            width: 100%; height: 2.8125rem; padding: 0.875rem 1rem 0.8125rem; font-size: 0.8125rem; color: #575757; margin-top: 1.25rem;
            background: #FFFFFF; border: 0.0625rem solid #CACACA; border-radius: 1.40625rem;
          }
        }
        // 
        // .popup__dialog, .popup__modal, .popup__popup {}
      }
      &.loading-pop_content {
        .popup-main {
          padding: 10px;
          min-width: auto;
        }
      }
    }
  }
</style>